import { defineStore } from 'pinia'

// State 用 TypeScript 型定義
interface MapViewState {
  baseMap: boolean
  aerialPhoto: boolean
  orthoPhoto: boolean
  slopeFailure: boolean
  debrisFlow: boolean
  landslide: boolean
  floodMaxScale: boolean
  floodPlannedScale: boolean
  tsunamiInundation: boolean
  gridFill: boolean
  gridLabelWide: boolean
  gridLabelMiddle: boolean
  point: boolean
  aerialAreasFill: boolean
  aerialAreasLine: boolean
}

/**
 * プロパティ名で表示・非表示を切り替えているため、
 * MAP_LAYERSのkeyと合わせること
 */
const initialState: MapViewState = {
  baseMap: true, // ベースマップ
  aerialPhoto: false, // 航空写真
  orthoPhoto: false, // オルソ画像
  slopeFailure: false, // 土砂災害警戒区域（急傾斜地の崩壊）
  debrisFlow: false, // 土砂災害警戒区域（土石流）
  landslide: false, // 土砂災害警戒区域（地すべり）
  floodMaxScale: false, // 洪水浸水想定区域（想定最大規模）
  floodPlannedScale: false, // 洪水浸水想定区域（計画規模）
  tsunamiInundation: false, // 津波浸水想定区域
  gridFill: true, // ヒートマップ（グリッド）
  gridLabelWide: false, // ヒートマップ（ラベル（広域））
  gridLabelMiddle: false, // ヒートマップ（ラベル（中域））
  point: true, // 建物マーカー
  aerialAreasFill: false, // ドローン空撮範囲（塗りつぶし）
  aerialAreasLine: false // ドローン空撮範囲（枠線）
}

export const useMapViewSettingsStore = defineStore('mapViewSettingsStore', {
  state: (): MapViewState => ({ ...initialState }),
  actions: {
    reset() {
      Object.assign(this.$state, initialState)
    }
  }
})
